"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBoxCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FormikCheckBox_1 = __importDefault(require("./formik/FormikCheckBox"));
function CheckBoxCell(props) {
    const { name, ...otherProps } = props;
    return ((0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { style: {
            container: { display: 'block', margin: '0 auto', width: 'fit-content' },
        }, name: name, ...otherProps }, name));
}
exports.CheckBoxCell = CheckBoxCell;
